import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Sheet, Button, Icon, Grid, Row, Col, Typography } from '@sm/wds-react';
import { getClientEnvironmentDetails } from '@sm/utils';
import { Logo } from '../Logos';

import './mobile-banner.scss';

export default class MobileBanner extends Component {
  constructor(props) {
    super(props);
    const isUserEligible = this.isUserEligible();

    this.state = {
      showBanner: true,
      isUserEligible,
      sessionTime: new Date().getTime(),
    };
  }

  isUserEligible = () => {
    const environmentDetails = getClientEnvironmentDetails();
    if (
      environmentDetails.isMobile &&
      !environmentDetails.isNode &&
      this.getCookie('sb-closed') !== 'true' &&
      this.getCookie('sb-installed') !== 'true'
    ) {
      return true;
    }
    return false;
  };

  getCookie = name => {
    const environmentDetails = getClientEnvironmentDetails();
    const match = environmentDetails.isNode
      ? null
      : document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
    if (match) {
      return match[2];
    }
    return null;
  };

  setCookie = name => {
    // Set close cookie
    const dateRightNow = new Date();
    const expiryDate = new Date(
      dateRightNow.getTime() + 15 * 24 * 60 * 60 * 1000
    );
    const cookieValue = `${encodeURI(
      true
    )}; expires=${expiryDate.toUTCString()}`;
    document.cookie = `${name}=${cookieValue}; path=/;`;
  };

  getDownloadLink = () => {
    let { downloadLink } = this.props;
    const { deepLinkData } = this.props;
    if (!downloadLink) {
      // eslint-disable-next-line no-throw-literal
      throw 'no download link';
    }
    downloadLink = `${downloadLink}?path=${encodeURIComponent(
      window.location.pathname
    )}`;
    if (deepLinkData && Object.keys(deepLinkData).length !== 0) {
      downloadLink = `${downloadLink}&${Object.keys(deepLinkData)
        .map(
          k => `${encodeURIComponent(k)}=${encodeURIComponent(deepLinkData[k])}`
        )
        .join('&')}`;
    }
    downloadLink = `${downloadLink}&session=${this.state.sessionTime}`;
    return downloadLink;
  };

  handleOnClose = () => {
    this.setCookie('sb-closed');
    this.setState({ showBanner: false });
  };

  handleInstallClick = () => {
    const downloadLink = this.getDownloadLink();
    this.setCookie('sb-installed');
    this.setState({ showBanner: false });
    window.location.href = downloadLink;
  };

  handleOpenClick = () => {
    const downloadLink = this.getDownloadLink();
    this.setCookie('sb-closed');
    this.setState({ showBanner: false });
    window.location.href = downloadLink;
  };

  getRatingStars = () => {
    const environmentDetails = getClientEnvironmentDetails();
    let starRating = this.props.iosRating;
    const starRatingNodes = [];
    if (environmentDetails.isAndroid) {
      starRating = this.props.androidRating;
    }
    for (
      let starCount = 0;
      starCount < starRating && starCount < 5;
      starCount += 1
    ) {
      starRatingNodes.push(
        <Icon key={starCount} color="upgrade">
          Û
        </Icon>
      );
    }
    for (let starCount = starRating; starCount < 5; starCount += 1) {
      starRatingNodes.push(
        <Icon key={starCount} className="sm-mobile-banner--rating--empty">
          Û
        </Icon>
      );
    }
    return starRatingNodes;
  };

  getRatingText = () => {
    const environmentDetails = getClientEnvironmentDetails();
    let starRatingText = this.props.iosRatingText;
    if (environmentDetails.isAndroid) {
      starRatingText = this.props.androidRatingText;
    }
    return (
      <Typography component="div" variant="cardTitle" className="wds-p-r-1">
        {starRatingText}
      </Typography>
    );
  };

  render() {
    return (
      this.state.isUserEligible && (
        <Sheet
          show={this.state.showBanner}
          blocking={false}
          placement="bottom"
          onClose={this.handleOnClose}
          closeButton
        >
          <Grid className="wds-p-1">
            <Row className="wds-flex--between wds-flex wds-flex--y-center wds-m-r-6">
              <Col xs={2}>
                <Logo className="sm-mobile-banner--logo" />
              </Col>
              <Col>
                <Row className="wds-flex--x-end wds-flex sm-mobile-banner--rating">
                  {this.getRatingText()}
                  {this.getRatingStars()}
                </Row>
                <Row className="wds-flex wds-flex--y-center wds-flex--x-end">
                  <div>
                    <Button
                      className="wds-m-1"
                      onClick={this.handleInstallClick}
                    >
                      {this.props.installText}
                    </Button>
                    <Button
                      color="alt"
                      className="wds-m-1"
                      onClick={this.handleOpenClick}
                    >
                      {this.props.deepLinkText}
                    </Button>
                  </div>
                </Row>
              </Col>
            </Row>
          </Grid>
        </Sheet>
      )
    );
  }
}

MobileBanner.propTypes = {
  iosRatingText: PropTypes.string,
  iosRating: PropTypes.number,
  androidRatingText: PropTypes.string,
  androidRating: PropTypes.number,
  deepLinkText: PropTypes.string,
  installText: PropTypes.string,
  downloadLink: PropTypes.string.isRequired,
  deepLinkData: PropTypes.object, // eslint-disable-line
};

MobileBanner.defaultProps = {
  iosRatingText: 'SurveyMonkey on iOS',
  iosRating: 4,
  androidRatingText: 'SurveyMonkey on Android',
  androidRating: 4,
  deepLinkText: 'Open in App',
  installText: 'Install',
  deepLinkData: {},
};
